import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import hayatlogo from '../../assets/images/hayatlogo.jpg';
import hayatin from '../../assets/images/hayatin.jpg';
import "../auth/Otp.css";
import axios from 'axios';
import { BACKEND_URL } from '../common/Common';

const Otp = () => {
    const navigate = useNavigate();
    const [otp, setOtp] = useState(["", "", "", ""]);
    const [timer, setTimer] = useState(60);
    const inputRefs = useRef([]);
    const [registerverifyotp, setRegisterVerifyOtp] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [dialCode, setDialCode] = useState("+971"); // Default to +971, will be updated from API response

    // Get registration data from localStorage
    const [registrationData, setRegistrationData] = useState({
        mobile: "",
        email: "",
        name: "",
        password: ""
    });

    // Load registration data from localStorage on component mount
    useEffect(() => {
        const mobile = localStorage.getItem('registerMobile') || "";
        const email = localStorage.getItem('registerEmail') || "";
        const name = localStorage.getItem('registerName') || "";
        const password = localStorage.getItem('registerPassword') || "";

        // Log registration data being loaded
        console.log("Registration Data Loaded from localStorage:", {
            mobile: mobile,
            email: email,
            name: name,
            password: password ? "***" : "" // Don't log password
        });

        // Log all localStorage items for debugging
        console.log("All localStorage items:", {
            registerMobile: localStorage.getItem('registerMobile'),
            registerEmail: localStorage.getItem('registerEmail'),
            registerName: localStorage.getItem('registerName'),
            registerPassword: localStorage.getItem('registerPassword') ? "***" : null
        });

        setRegistrationData({
            mobile,
            email,
            name,
            password
        });
    }, []);
    // Countdown timer
    useEffect(() => {
        if (timer === 0) return;
        const interval = setInterval(() => {
            setTimer(prev => prev - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [timer]);

    // Handle OTP input
    const handleChange = (value, index) => {
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 3) {
            inputRefs.current[index + 1].focus();
        }
    };

    // Handle backspace
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    // Helper function to format mobile number with dial code
    const formatMobileWithDialCode = (mobile, dialCodeToUse, withSpace = true) => {
        let cleanMobile = mobile || "";
        
        // Remove any existing dial code from the mobile number
        // Handle cases like: "+971598398839" or "+971 598398839" or "598398839"
        if (cleanMobile.startsWith('+')) {
            // If mobile starts with the dial code, remove it
            if (cleanMobile.startsWith(dialCodeToUse)) {
                cleanMobile = cleanMobile.substring(dialCodeToUse.length);
            } else {
                // Remove any leading + and country code digits (1-4 digits after +)
                cleanMobile = cleanMobile.replace(/^\+\d{1,4}\s?/, '');
            }
        }
        
        // Trim any leading/trailing spaces
        cleanMobile = cleanMobile.trim();
        
        // Construct mobile with dial code: +971 598398839 (with space) or +971598398839 (without space)
        return withSpace ? `${dialCodeToUse} ${cleanMobile}` : `${dialCodeToUse}${cleanMobile}`;
    };

    // Helper function to get clean mobile number without dial code
    const getCleanMobileNumber = (mobile, dialCodeToUse) => {
        let cleanMobile = mobile || "";
        
        // Remove any existing dial code from the mobile number
        if (cleanMobile.startsWith('+')) {
            // If mobile starts with the dial code, remove it
            if (cleanMobile.startsWith(dialCodeToUse)) {
                cleanMobile = cleanMobile.substring(dialCodeToUse.length);
            } else {
                // Remove any leading + and country code digits (1-4 digits after +)
                cleanMobile = cleanMobile.replace(/^\+\d{1,4}\s?/, '');
            }
        }
        
        // Trim any leading/trailing spaces
        return cleanMobile.trim();
    };

    const handleSubmit = async () => {
        // Prevent double submission
        if (isSubmitting) {
            return;
        }

        const enteredOtp = otp.join("");
        if (enteredOtp.length !== 4) {
            alert("Please enter valid OTP");
            return;
        }

        // Set submitting state to prevent double clicks
        setIsSubmitting(true);

        try {
            // Try to reload data from localStorage if missing
            let currentData = { ...registrationData };
            if (!currentData.mobile || !currentData.email || !currentData.name || !currentData.password) {
                console.log("Registration data missing in state, attempting to reload from localStorage...");
                const mobile = localStorage.getItem('registerMobile') || "";
                const email = localStorage.getItem('registerEmail') || "";
                const name = localStorage.getItem('registerName') || "";
                const password = localStorage.getItem('registerPassword') || "";

                currentData = { mobile, email, name, password };
                setRegistrationData(currentData);

                console.log("Reloaded Registration Data:", {
                    mobile: mobile,
                    email: email,
                    name: name,
                    password: password ? "***" : ""
                });
            }

            // Validate that we have all required data
            if (!currentData.mobile || !currentData.email || !currentData.name || !currentData.password) {
                console.error("Registration data still missing after reload:", currentData);
                alert("Registration data is missing. Please register again.");
                setIsSubmitting(false);
                navigate("/register");
                return;
            }

            // Log registration data before API calls
            console.log("Submitting OTP with Registration Data:", {
                mobile: currentData.mobile,
                email: currentData.email,
                name: currentData.name,
                password: "***"
            });

            // First verify OTP
            const otpVerified = await fetchregisterverifyotp(enteredOtp);

            if (otpVerified) {
                // If OTP verification successful, create customer
                const customerResponse = await fetchcreatecustomer();

                if (customerResponse && customerResponse.success) {
                    // Store authentication data (similar to login flow)
                    const responseData = customerResponse.data;
                    console.log("Full Customer Creation Response Data:", responseData);
                    
                    if (responseData) {
                        // Handle different response structures
                        let userId = null;
                        let userObject = null;
                        let token = null;

                        // Check if user data is nested in 'user' object (like login API)
                        if (responseData.user) {
                            userObject = responseData.user;
                            userId = responseData.user_id || responseData.user.id || responseData.user.user_id;
                            token = responseData.token;
                        } 
                        // Check if user data is at root level
                        else if (responseData.id || responseData.user_id) {
                            userObject = responseData;
                            userId = responseData.user_id || responseData.id;
                            token = responseData.token;
                        }
                        // Check if response has data property with user info
                        else if (responseData.data) {
                            userObject = responseData.data.user || responseData.data;
                            userId = responseData.data.user_id || responseData.data.id || responseData.user_id;
                            token = responseData.data.token || responseData.token;
                        }

                        // Store user_id
                        if (userId) {
                            localStorage.setItem('user_id', userId.toString());
                            console.log("Stored user_id:", userId);
                        }

                        // Store token
                        if (token) {
                            localStorage.setItem('token', token);
                            console.log("Stored token");
                        }

                        // Store user object
                        if (userObject) {
                            localStorage.setItem('user', JSON.stringify(userObject));
                            console.log("Stored user object:", userObject);
                        } else {
                            console.warn("No user object found in response. Response structure:", responseData);
                            // Fallback: Create a minimal user object from registration data if we have userId
                            if (userId) {
                                const fallbackUser = {
                                    id: userId,
                                    user_id: userId,
                                    name: registrationData.name,
                                    email: registrationData.email,
                                    mobile: registrationData.mobile
                                };
                                localStorage.setItem('user', JSON.stringify(fallbackUser));
                                console.log("Stored fallback user object:", fallbackUser);
                            }
                        }

                        // Dispatch custom event to notify Navbar of login state change
                        if (userId) {
                            window.dispatchEvent(new Event('userLoginStateChanged'));
                        }
                    }

                    // Clear localStorage after successful registration
                    localStorage.removeItem('registerMobile');
                    localStorage.removeItem('registerEmail');
                    localStorage.removeItem('registerName');
                    localStorage.removeItem('registerPassword');

                    // Set flag to indicate new customer was just created
                    localStorage.setItem('newCustomerCreated', 'true');

                    // Small delay to ensure localStorage is updated before navigation
                    setTimeout(() => {
                        // Navigate to Home page
                        navigate("/");
                    }, 100);
                } else {
                    // Reset submitting state on error
                    setIsSubmitting(false);
                }
            } else {
                // Reset submitting state on error
                setIsSubmitting(false);
            }
        } catch (error) {
            // Handle unexpected errors
            console.error("Unexpected error during OTP submission:", error);
            alert("An unexpected error occurred. Please try again.");
            setIsSubmitting(false);
        }
    };

    const fetchregisterverifyotp = async (enteredOtp) => {
        // Format mobile number with dial code without space for verify-otp
        // This matches the format used in register-send-otp: +971598398839
        // Use current dialCode state (defaults to +971 if not yet set from API)
        const formattedMobile = formatMobileWithDialCode(registrationData.mobile, dialCode, false);
        
        const payload = {
            mobile: formattedMobile,
            otp: enteredOtp,
            email: registrationData.email,
        }
        console.log("OTP Verification Payload:", payload);

        try {
            const response = await axios.post(`${BACKEND_URL}website/register-verify-otp`, payload);
            // const response = await axios.post(`http://localhost:8000/api/website/register-verify-otp`, payload);
            setRegisterVerifyOtp(response.data);
            console.log("OTP Verification Response:", response.data);
            
            // Extract dial_code from API response
            if (response.data && response.data.dial_code) {
                setDialCode(response.data.dial_code);
                console.log("Dial code extracted from API:", response.data.dial_code);
            } else if (response.data && response.data.data && response.data.data.dial_code) {
                setDialCode(response.data.data.dial_code);
                console.log("Dial code extracted from API (nested):", response.data.data.dial_code);
            }
            
            return true;
        } catch (error) {
            console.log("Error fetching the Register Verify Otp:", error);
            alert("OTP verification failed. Please check your OTP and try again.");
            return false;
        }
    }

    const fetchcreatecustomer = async () => {
        // Get clean mobile number without dial code since we're sending dial_code separately
        // This prevents duplication: dial_code (+971) + mobile (547838331) instead of mobile (+971547838331)
        const cleanMobile = getCleanMobileNumber(registrationData.mobile, dialCode);
        
        const payload = {
            email: registrationData.email,
            dial_code: dialCode,
            mobile: cleanMobile, // Send only the mobile number without dial code
            password: registrationData.password,
            name: registrationData.name,
            device_type: "web"
        }
        // console.log("Customer Creation Payload:", payload);
        try {
            const response = await axios.post(`${BACKEND_URL}website/create-customer`, payload);
            // const response = await axios.post(`http://localhost:8000/api/website/create-customer`, payload);
            setRegisterVerifyOtp(response.data);
            console.log("Customer Creation Response:", response.data);
            return { success: true, data: response.data };
        } catch (error) {
            console.log("Error creating customer:", error);
            alert("Failed to create account. Please try again.");
            return { success: false, data: null };
        }
    }

    return (
        <div className="register-container">
            <div className="register-left">
                <img src={hayatlogo} alt="Register" />
            </div>

            <div className="register-right">
                <div className="rightside-header">
                    <img src={hayatin} alt="hayatin" />
                </div>

                <div className="center-banner" style={{
                    position:"relative",
                    top:"100px"
                }}>
                    <div className="register-heading">
                        <h4>Enter Your OTP</h4>
                    </div>

                    <div className="otp-container">
                        <p className="otp-description">
                            An OTP has been sent to your registered number ending in {registrationData.mobile ? registrationData.mobile.slice(-4) : '****'}.
                            Kindly enter it to Proceed
                        </p>
                        <p className="mobile-num-change">Change Mobile Number</p>

                        {/* OTP Boxes */}
                        <div className="otp-box-wrapper">
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    maxLength="1"
                                    value={digit}
                                    onChange={(e) =>
                                        handleChange(e.target.value, index)
                                    }
                                    onKeyDown={(e) =>
                                        handleKeyDown(e, index)
                                    }
                                    ref={(el) =>
                                        (inputRefs.current[index] = el)
                                    }
                                    className="otp-box"
                                />
                            ))}
                        </div>

                        {/* Timer */}
                        {/* <p className="otp-timer">
                            {timer > 0 ? `0:${timer < 10 ? `0${timer}` : timer} sec` : "OTP Expired"}
                        </p> */}
                    </div>
                    {/* Submit */}
                    <button
                        className="otp-submit-btn"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Otp;
